import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getUploadUrls = (
  filesData: {
    fileName: string
    contentType?: string
    folder?: string
    size?: number
    relationId?: string
    relationType?: string
    createdBy?: string
    type?: string
  }[],
) => {
  return useApi(
    http.post(`/files`, filesData, {
      headers: { 'Content-Type': 'application/json' },
    }),
  )
}

export const uploadFileViaBackend = (file: File, folder?: string) => {
  const formData = new FormData()

  formData.append('file', file)
  if (folder) {
    formData.append('folder', folder)
  }

  return useApi(
    http.post(`/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  )
}

export const uploadFileDirectly = async (presignedUrls: any, files: any) => {
  try {
    await Promise.all(
      presignedUrls.map((presignedUrl: any, index: number) =>
        fetch(presignedUrl.url, {
          method: 'PUT',
          body: files[index],
          headers: { 'Content-Type': files[index].type },
        }),
      ),
    )

    return { success: true }
  } catch (error) {
    console.error('Error on uploading to S3:', error)

    return { success: false, error }
  }
}

export const getFilesByRelation = (relationId: string) => {
  return useApi(http.get(`/files`, { params: { relationId } }))
}
export const downloadFile = (fileId: string, isDownload: boolean = false) => {
  const queryParam = isDownload ? '?download=true' : ''

  return useApi(
    http.get(`/download/${fileId}${queryParam}`, {
      responseType: 'blob',
    }),
  )
}

export const deleteFile = (fileId: string) => {
  return useApi(http.delete(`/files/${fileId}`))
}
